module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-stone-path-remnants.fb43b49a.png";